import React, { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import Decimal from 'decimal.js';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { formatNumber } from '../../../../../../../CommonUtils/formatNumber';
import { HelperText } from '../../../../../../../CommonComponents/OPL/HelperText/HelperText';

export const AssetsAllocationTableTotal = () => {
  const chartValues = useWatch({
    name: 'accountPortfolio.assets',
  });

  const [allocationTotal, isAllocationInvalid] = useMemo(() => {
    if (!chartValues) {
      return [0, false];
    }

    const total = chartValues.reduce((acc, currentAssetValue) => {
      if (currentAssetValue.y) {
        return new Decimal(acc).plus(currentAssetValue.y).toNumber();
      }

      return acc;
    }, 0);

    const isInvalid = total !== 100;

    return [total, isInvalid];
  }, [chartValues]);

  return (
    <Box display="flex" flexDirection="column" pt="16">
      <Box display="flex" justifyContent="space-between">
        <Text fontWeight={600} color="neutral.600">
          Total
        </Text>

        <Text fontWeight={600}>
          {formatNumber(allocationTotal, {
            decimalPlaces: 2,
            thousandSeparated: false,
          })}
          %
        </Text>
      </Box>

      {isAllocationInvalid && (
        <Box alignSelf="flex-end">
          <HelperText variant="error" mt="4">
            The total must add up to 100%
          </HelperText>
        </Box>
      )}
    </Box>
  );
};
